import { Box, FormControl, Grid, MenuItem, Select, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { UseSetLenguajePorPais } from "../hooks/UseSetLenguajePorPais";
import { useAuthContext } from "../hooks/Auth";
import { get_niveles_organizacion } from "../services/api";

export default function GetNivelesOrganizacion({ onNivelChange, selectedNivel }) {
  const [data, setData] = useState([]);
  const [selectedNivelId, setSelectedNivelId] = useState("");
  const { t } = useTranslation();
  const { user } = useAuthContext();

  UseSetLenguajePorPais();

  const organizacionId = user?.id_organizacion;

  useEffect(() => {
    let isMounted = true;

    async function ObtenerDatosDeAPI() {
      if (!organizacionId) {
        console.error(
          "GetNivelesOrganizacion: No se encontró organizacionId en el contexto del usuario"
        );
        if (isMounted) setData([]);
        return;
      }

      try {
        const { data: resp, status } = await get_niveles_organizacion(organizacionId);

        if (status === 200) {
          const body = resp?.body ?? [];

          const nivelesArray = Array.isArray(body)
            ? body.map((n) => ({
                id: String(n?.id_nivel ?? ""),
                nombre: String(n?.nombre ?? ""),
              }))
            : [];

          if (isMounted) setData(nivelesArray);
        } else {
          console.error(
            "GetNivelesOrganizacion: La solicitud a la API no fue exitosa."
          );
          if (isMounted) setData([]);
        }
      } catch (error) {
        console.error(
          "GetNivelesOrganizacion: Se produjo un error al realizar la solicitud a la API:",
          error
        );
        if (isMounted) setData([]);
      }
    }

    ObtenerDatosDeAPI();

    return () => {
      isMounted = false;
    };
  }, [organizacionId]);

  

  useEffect(() => {
    if (selectedNivel) {
      setSelectedNivelId(selectedNivel);
    }
  }, [selectedNivel, data]);

  useEffect(() => {
    setSelectedNivelId(selectedNivel || "");
  }, [selectedNivel]);

  const handleNivelChange = (event) => {
    const nextSelectedNivelId = event.target.value;
    const selectedNivelObj = data.find((nivel) => nivel.id === nextSelectedNivelId);

    if (selectedNivelObj) {
      setSelectedNivelId(nextSelectedNivelId);

   
      onNivelChange(selectedNivelObj.nombre, selectedNivelObj.id);
    } else {
      setSelectedNivelId("");
      onNivelChange("", "");
    }
  };

  return (
    <Grid item xs={12}>
      <Box>
        <Typography
          sx={{
            fontFamily: "montserrat",
            fontSize: "1.25rem",
            fontWeight: "bold",
            color: "#336B87",
          }}
        >
          {t("nivel")}
        </Typography>

        <FormControl fullWidth>
          <Select
            labelId="select-nivel-organizacion"
            id="select-nivel-organizacion"
            variant="outlined"
            displayEmpty
            value={selectedNivelId}
            onChange={handleNivelChange}
            sx={{
              fontFamily: "montserrat",
              fontSize: "14px",
              borderRadius: 2,
              "& .MuiOutlinedInput-root": { borderRadius: 2 },
              "& fieldset": { borderColor: "#BDBDBD" },
              "&:hover fieldset": { borderColor: "#9E9E9E" },
              "&.Mui-focused fieldset": { borderColor: "#005559" },
              "& .MuiSelect-select": {
                color: selectedNivel ? "#005559" : "#B3D1D1",
              },
            }}
          >
            <option hidden value="">
              Selecciona hasta 1 opción máximo.
            </option>

            {data.map((nivel) => (
              <MenuItem
                key={nivel.id}
                value={nivel.id}
                sx={{ color: "#336B87" }}
              >
                <Typography
                  sx={{
                    fontFamily: "montserrat",
                    fontSize: "0.8rem",
                    color: "#336B87",
                  }}
                >
                  {nivel.nombre}
                </Typography>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Grid>
  );
}